module.exports = __webpack_public_path__ + "img/tuijian1.de52e372.png";